import React, { useState } from "react";
import { Button } from "@/components/ui/button";
import { Gavel, ArrowRight } from "lucide-react";
import { useAuth } from "@/hooks/useAuth";
import { useNavigate } from "react-router-dom";
import AuthDialog from "@/components/auth/AuthDialog";
import { useLanguage } from "@/context/LanguageContext";
import { commonLabels } from "@/i18n";

const HeroContent = () => {
  const { language } = useLanguage();
  const labels = commonLabels(language);
  const heroData = labels.menuPages?.buyCar?.hero || {};
  const [showAuthDialog, setShowAuthDialog] = useState(false);
  const { isAuthenticated } = useAuth();
  const navigate = useNavigate();

  const handleBtnClick = () => {
    if (!isAuthenticated) {
      setShowAuthDialog(true);
    } else {
      navigate("/auctions");
    }
  };

  return (
    <div className="text-white space-y-6 md:space-y-8 max-w-5xl mx-auto px-4">
      {heroData.badge && (
        <div className="mb-3 md:mb-4">
          <span className="inline-block bg-gradient-to-r from-blue-500 to-purple-500 text-white px-4 md:px-8 py-2 md:py-3 rounded-full text-xs md:text-sm font-medium shadow-lg">
            {heroData.badge}
          </span>
        </div>
      )}

      <h1 className="text-5xl md:text-6xl lg:text-8xl font-bold mb-6 md:mb-8 bg-gradient-to-r from-white via-blue-200 to-purple-200 bg-clip-text text-transparent leading-tight">
        {heroData.title || "Köp Din"}
        <br />
        <span className="bg-gradient-to-r from-blue-400 to-purple-400 bg-clip-text text-transparent">
          {heroData.titleHighlight || "Drömbil"}
        </span>
        <br />
        {heroData.titleSuffix || "På Auktion"}
      </h1>

      <p className="text-xl md:text-xl lg:text-2xl text-gray-300 mb-8 md:mb-12 max-w-4xl mx-auto leading-relaxed px-2">
        {heroData.description ||
          "Buda på tusentals bilar med transparent testning. Olika auktionstyper från 24 timmar till 7 dagar."}
      </p>

      <div className="flex flex-col sm:flex-row gap-4 md:gap-6 justify-center mb-12 md:mb-16 px-4">
        <Button
          onClick={handleBtnClick}
          size="lg"
          className="text-white md:text-lg px-8 md:px-10 py-4 md:py-6 bg-gradient-to-r from-blue-600 to-purple-600 hover:from-blue-700 hover:to-purple-700 border-0 shadow-2xl rounded-full font-semibold transition-all duration-300 hover:scale-105"
        >
          <Gavel className="mr-2 md:mr-3 w-4 h-4 md:w-5 md:h-5 " />
          {heroData.button || "Se pågående auktioner"}
          <ArrowRight className="ml-2 md:ml-3 w-4 h-4 md:w-5 md:h-5" />
        </Button>
      </div>
      <AuthDialog open={showAuthDialog} onOpenChange={setShowAuthDialog} />
    </div>
  );
};

export default HeroContent;
